import styled from 'styled-components';
import AppBar from '@material-ui/core/AppBar';
import Menu from '@material-ui/core/Menu';

export const AppBarStyled = styled(AppBar)`
  ${(props) => `    
    width: 100%;
    box-shadow: 4px 3px 4px 0px rgba(0,0,0,0.12);
    
    ${props.theme.breakpoints.up('lg')} {
      width: calc(100vw - 19rem);
    }
    
    ${props.theme.breakpoints.up('xl')} {
      width: calc(100vw - 21.6rem);
    }
    
    & .app-tool-bar {
        padding-left: 20px;
        padding-right: 20px;
        min-height: 56px;
        
        ${props.theme.breakpoints.up('sm')} {
          min-height: 70px;
        }
        
        ${props.theme.breakpoints.up('md')} {
          padding-left: 30px;
          padding-right: 30px;
        }
    }
    
    & .grow {
       flex-grow: 1;
    }
    
    & .menu-button {
        margin-right: ${props.theme.spacing(2)};
    }
    
    & .menu-icon {
        width: 35px;
        height: 35px;
    }
    
    & .section-desktop {
        min-height: 58px;
        display: none;
        
        ${props.theme.breakpoints.up('md')} {
          display: flex;
        }
        
        ${props.theme.breakpoints.up('xl')} {
          min-height: 65px;
        }
    }
    
    & .section-mobile {
        display: flex;
        
        ${props.theme.breakpoints.up('md')} {
          display: none;
        }
    }
      
  `}
`;

export const MenuStyled = styled(Menu)`
  & .menu-item {
    padding: 0;
  }
`;
